import { gql } from '@apollo/client'

export const RATEPLANS_QUERY = gql`
  query RatePlans(
    $propertyCode: String!
    $roomTypeCode: String
    $showDeletedRatePlans: Boolean!
    $showDeactivedRatePlans: Boolean!
    $providerCode: String
    $showLog: Boolean
  ) {
    ratePlans(
      propertyCode: $propertyCode
      roomTypeCode: $roomTypeCode
      showDeletedRatePlans: $showDeletedRatePlans
      showDeactivedRatePlans: $showDeactivedRatePlans
      providerCode: $providerCode
      showLog: $showLog
    ) {
      id
      name
      ratePlanCode
      displayRatePlanCode
      roomTypeCode
      displayRoomTypeCode
      numberOfRates
      boardType
      roomTypeID
      roomTypeName
      accommodationID
      deleted
      active
      type
      providerCode
      providerName
    }
  }
`

export const RATEPLAN_QUERY = gql`
  query RatePlan(
    $propertyCode: String
    $roomTypeCode: String
    $ratePlanCode: String
    $accommodationId: String
    $roomTypeId: String
    $ratePlanId: String
  ) {
    ratePlan(
      propertyCode: $propertyCode
      roomTypeCode: $roomTypeCode
      ratePlanCode: $ratePlanCode
      accommodationId: $accommodationId
      roomTypeId: $roomTypeId
      ratePlanId: $ratePlanId
    ) {
      basicDetails {
        type
        roomTypeCode
        parentRatePlanCode
        name
        nameTranslatedList {
          value
          label
          nativeLabel
        }
        ratePlanCode
        displayRatePlanCode
        boardType
        ratePolicy
        ratePolicyTranslatedList {
          value
          label
          nativeLabel
        }
        ratePlanID
        roomTypeID
        roomTypeCode
        displayRoomTypeCode
        roomTypeName
        roomTypeNameTranslatedList {
          value
          label
          nativeLabel
        }
        accommodationId
        providerCode
        displayProviderCode
        active
        deleted
        roomTypeName
        roomTypeNameTranslatedList {
          value
          label
          nativeLabel
        }
      }
      supportedWalletTypes {
        currency
        walletTypes
      }
    }
  }
`

export const RATEPLAN_NAME_QUERY = gql`
  query RatePlanName(
    $propertyCode: String
    $roomTypeCode: String
    $ratePlanCode: String
    $accommodationId: String
    $roomTypeId: String
    $ratePlanId: String
  ) {
    ratePlanName(
      propertyCode: $propertyCode
      roomTypeCode: $roomTypeCode
      ratePlanCode: $ratePlanCode
      accommodationId: $accommodationId
      roomTypeId: $roomTypeId
      ratePlanId: $ratePlanId
    ) {
      name
      ratePlanCode
      roomTypeCode
    }
  }
`
